import { render, staticRenderFns } from "./GoTV.vue?vue&type=template&id=accc83f6&scoped=true&"
import script from "./GoTV.vue?vue&type=script&lang=js&"
export * from "./GoTV.vue?vue&type=script&lang=js&"
import style0 from "./GoTV.vue?vue&type=style&index=0&id=accc83f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc83f6",
  null
  
)

export default component.exports